import React from "react";
import { ToolRendererProps } from "./types";

export const SupabaseDeployEdgeFunctionToolRenderer: React.FC<
  ToolRendererProps
> = ({ args, renderWithErrorIfFailed, getFallbackText }) => {
  const edgeFunctionPath = args?.relativeEdgeFunctionFilePath || "";
  return edgeFunctionPath
    ? renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400">
          {edgeFunctionPath}
        </span>,
      )
    : getFallbackText();
};

export const SupabaseRunMigrationToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const migrationName = args?.relativeMigrationFilePath || "";
  return migrationName
    ? renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400">{migrationName}</span>,
      )
    : getFallbackText();
};
